import { render, staticRenderFns } from "./UserProfileLite.vue?vue&type=template&id=2a66939f&"
import script from "./UserProfileLite.vue?vue&type=script&lang=js&"
export * from "./UserProfileLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports